import React from "react";
import PropTypes from "prop-types";
import Skeleton from "./Skeleton";

export default function TextSkeleton({
  lines = 1,
  lineHeight,
  lastLineWidth = "65%",
  heading = false,
  gap = 8,
  width = "100%",
  className = "",
  style = {},
  ...rest
}) {
  const defaultHeight = heading ? 22 : 12;
  const height = lineHeight || defaultHeight;
  const radius = heading ? 6 : 4;

  if (lines <= 1) {
    return (
      <Skeleton
        variant="text"
        width={width}
        height={height}
        radius={radius}
        className={className}
        style={style}
        {...rest}
      />
    );
  }

  return (
    <div
      className={`app-skeleton-text-group ${className}`.trim()}
      style={{ gap, width, ...style }}
      aria-hidden="true"
    >
      {Array.from({ length: lines }, (_, idx) => {
        const isLast = idx === lines - 1;
        const lineWidth = isLast ? lastLineWidth : "100%";
        return (
          <Skeleton
            key={idx}
            variant="text"
            width={lineWidth}
            height={height}
            radius={radius}
            {...rest}
          />
        );
      })}
    </div>
  );
}

TextSkeleton.propTypes = {
  lines: PropTypes.number,
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lastLineWidth: PropTypes.string,
  heading: PropTypes.bool,
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.object,
};
